import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-tabs',
  templateUrl: './cardtabs.component.html',
})
export class CardTabsComponent {
  @Input() tabitems: any;
  @Input() backLink: any;

  public collapsed = true;

  public toggleCollapse() {
    this.collapsed = !this.collapsed;
  }
}
